export const localStorageKey = {
  auth_status: 'auth',
  redirect_to: 'redirect_to',
};
